export default __webpack_public_path__ + "static/media/67@2x-8.0720ca4f.png";